import stylyed from "styled-components";
export const InputContainer = stylyed.div`
display: flex;
width: 100%;
height: 63px;
align-items: center;
padding: 0 .5rem;
border-radius: 4px;
background: ${({ theme: { colors } }) => colors.gray200};
`;
export const InputField = stylyed.input`
    border: none;
    outline:none;
    width: 100%;
    height: 100%;
    background: transparent;
    font-size: 1rem;
    color:${({ theme: { colors } }) => colors.gray500};
    margin:0 .5rem;
    outline:none !important;
`;
export const Icon = stylyed.img`
    margin:0 .5rem;
`;
